export const useGetImpersonateEnabled = (appConfiguration = null) => {
  let enabled = false

  if (appConfiguration) {
    enabled = appConfiguration.impersonateEnabled
  }

  return enabled
}
